export default __webpack_public_path__ + "static/SoftwareMPY-1be4e06707a39f22f7d5871195b8d415.png";